var map = {
	"./Appmagic.png": 19439,
	"./account.svg": 12064,
	"./action_icon.svg": 53887,
	"./add-icon.png": 84280,
	"./adjust-logo.png": 366,
	"./aggregated-cohort-data-icon.png": 71183,
	"./analytics.svg": 74325,
	"./analytics_dark.svg": 62132,
	"./android_logo.svg": 55054,
	"./app-store.png": 90704,
	"./applovin_logo.svg": 67316,
	"./appmagic-logo.svg": 95815,
	"./appmagic-yellow-logo.svg": 66870,
	"./appsflyer-logo.png": 13203,
	"./appstore-icon-3x.png": 84395,
	"./bell_icon.svg": 27140,
	"./benchmarks_flag_icon.png": 61590,
	"./big-query-logo.png": 24486,
	"./calculator-output-icon.svg": 25623,
	"./chevron-down.svg": 79573,
	"./clayrio_logo.svg": 18360,
	"./cohort-analytics-icon.svg": 3407,
	"./copy-down.svg": 74953,
	"./cumulative-profits-icon.svg": 66994,
	"./dashboard_lock.svg": 71629,
	"./data-source/data_source_adjust.svg": 65152,
	"./data-source/data_source_aggregated_data.svg": 67305,
	"./data-source/data_source_apps_flyer.svg": 78138,
	"./data-source/data_source_none.svg": 86635,
	"./data-source/data_source_user_trx_data.svg": 1962,
	"./delete-icon.png": 47724,
	"./delete.svg": 90930,
	"./dollar-icon.svg": 70749,
	"./donut_icon_deals.svg": 92087,
	"./donut_icon_filled.svg": 76438,
	"./donut_icon_referrer.svg": 14663,
	"./dotted_circle.svg": 29206,
	"./dotted_circle_selected.svg": 73194,
	"./download-black.svg": 23601,
	"./download_icon.svg": 58657,
	"./download_icon_green.svg": 44461,
	"./edit-icon-green.svg": 49173,
	"./facebook_logo.svg": 14771,
	"./filter_icon.svg": 68575,
	"./flexible-disbursements-icon.svg": 14123,
	"./form.svg": 30217,
	"./fullscreen_exit_icon.svg": 17197,
	"./fullscreen_icon.svg": 63636,
	"./funding-assessment-icon.svg": 36917,
	"./funding-calander-icon.svg": 32253,
	"./gcs-logo.png": 5970,
	"./gear.svg": 47046,
	"./gear_round_icon.svg": 30305,
	"./getting-started-icon.svg": 58253,
	"./google-drive-logo.png": 83803,
	"./google_logo.svg": 48088,
	"./gradient-arrow.svg": 20215,
	"./green_icon.svg": 2888,
	"./green_tick.svg": 57548,
	"./icons/navbar/secondary-shape.svg": 28912,
	"./increase-icon.svg": 53407,
	"./industry-benchmarks-icon.svg": 17396,
	"./invoice.svg": 98292,
	"./invoice_dark.svg": 99827,
	"./ios_logo.svg": 99144,
	"./ironsource_logo.svg": 92024,
	"./key-metric-icon.png": 63781,
	"./letter-icon.svg": 32959,
	"./linkedin.png": 36871,
	"./linkedin.svg": 96049,
	"./logout.svg": 34277,
	"./module_fallback_icon.png": 57090,
	"./moloco_logo.svg": 14224,
	"./monthly-profits-icon.svg": 26374,
	"./mysql-logo.png": 56959,
	"./others_logo.svg": 69756,
	"./pdf-download.svg": 13348,
	"./pending-clock.svg": 37929,
	"./play-store-with-border.svg": 71709,
	"./play-store.png": 97755,
	"./playstore-icon-3x.png": 44362,
	"./plus_icon.svg": 17333,
	"./projections-tab_icon.svg": 40579,
	"./pvx-icon.svg": 6163,
	"./pvx-logo-full.svg": 58013,
	"./pvx-logo.svg": 95165,
	"./red-cross.svg": 76079,
	"./redo-icon.svg": 46443,
	"./report-form.svg": 9264,
	"./retention_chart_icon.svg": 41498,
	"./risk-protection-icon.svg": 49148,
	"./roas-projections-icon.svg": 3579,
	"./s3-logo.png": 55943,
	"./scenarios-tab_icon.svg": 10366,
	"./signular-logo.png": 25474,
	"./snowflake-logo.png": 11377,
	"./star.svg": 40815,
	"./star_dollar.svg": 71596,
	"./suggestion.svg": 55739,
	"./table-row-edit.svg": 22071,
	"./table-row-next.svg": 77156,
	"./table-row-view-green.svg": 7046,
	"./table-row-view-orange.svg": 93355,
	"./table-row-view.svg": 72932,
	"./three-dots.svg": 81462,
	"./tiktok_logo.svg": 58045,
	"./tour.svg": 32981,
	"./tour_dark.svg": 532,
	"./transaction-types-icon.svg": 66193,
	"./transparent-CoC-icon.svg": 25045,
	"./uaSpends_icon.svg": 74254,
	"./underwriting.svg": 79041,
	"./underwriting_dark.svg": 3992,
	"./unity_logo.svg": 60236,
	"./upload-icon.svg": 71722,
	"./upload_black.svg": 38324,
	"./user.svg": 10698,
	"./web_logo.svg": 22347,
	"./website-icon.png": 45238,
	"./yellow_icon.svg": 23905,
	"./zero-dilution-icon.svg": 93502
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25853;